import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-inform',
  templateUrl: './inform.component.html',
  styles: [
  ]
})
export class InformComponent implements OnInit {

  title: string = null;
  prompt: string = 'Are you sure?';

  constructor(private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  confirmModal(): void {
    this.modal.close();
  }

  dismissModal(): void {
    this.modal.dismiss();
  }
}
